import React, { useState, useContext, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { locations } from "../../data/Data";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
} from "@mui/material";
import { submitForm } from "../../api/apiManagement";
import { LoadingButton } from "@mui/lab";
import { FormContext } from "./Form";

const ConfirmPage = () => {
  const { setCurrentStep, data, setData } = useContext(FormContext);
  const [isLoading, setIsLoading] = useState(false);
  const matches = useMediaQuery("(max-width:480px)");

  const confirm_Location_operation_hours = locations.find(
    (loc) => loc.value === data?.location
  );
  const {
    shopTC,
    shopEN,
    previewOperationTimeTC,
    previewOperationTimeEN,
    value,
  } = confirm_Location_operation_hours;

  const back = () => {
    setCurrentStep(0);
  };

  useEffect(() => {
    console.log(data);
  }, []);

  const handleSubmitForm = async () => {
    let currentLang = "";
    if (data?.news_letters) {
      currentLang = data?.news_letters;
    }

    let submitData = {
      firstName: data?.first_name,
      lastName: data?.last_name,
      email: data?.email,
      phone: data?.select?.value + data?.mobile_number,
      newsLetter: data?.news_letters == "" ? 0 : 1,
      lang: currentLang,
      store: data?.location,
    };
    console.log(submitData);
    setIsLoading(true);
    submitForm(submitData)
      .then((res) => {
        const currentStatus = res.data.status;

        if (currentStatus === "200") {
          setCurrentStep(2);
        } else if (currentStatus === "500") {
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <Box>
      <Box sx={{ width: "100%", marginBottom: "20px" }}>
        <Typography
          variant={matches ? "subtitle2" : "subtitle1"}
          sx={{ marginBottom: "20px" }}
        >
          Please confirm your information:<br></br>
          請確認提交以下資料：
        </Typography>
        <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Last Name<br></br>
              姓氏
            </Box>
            <Box sx={{ width: "200px" }}>{data?.last_name}</Box>
          </Typography>
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              First Name<br></br>
              名字
            </Box>
            <Box sx={{ width: "200px" }}>{data?.first_name}</Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Mobile Number
              <Typography variant="subtitle2">
                (To receive WhatsApp messages)
              </Typography>
              流動電話號碼
              <Typography variant="subtitle2">
                (可接收 WhatsApp 訊息)
              </Typography>
            </Box>
            <Box sx={{ width: "200px" }}>
              +{data?.select?.value} {data?.mobile_number}
            </Box>
          </Typography>
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Email Address<br></br>
              電郵地址
            </Box>
            <Box sx={{ width: "200px" }}>{data?.email}</Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Samsung Experience Store<br></br>
              三星專門店
            </Box>
            <Box sx={{ width: "200px" }}>
              {shopEN}
              <br />
              {shopTC}
            </Box>
          </Typography>
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              Marketing info<br></br>
              市場推廣訊息語言
            </Box>
            <Box sx={{ width: "200px" }}>
              {data?.news_letters == "hk" ? (
                <span>
                  Traditional Chinese<br></br> 繁體中文
                </span>
              ) : data?.news_letters == "hk_en" ? (
                <span>
                  English <br></br>英文
                </span>
              ) : (
                <span>N/A</span>
              )}
            </Box>
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: matches ? "column" : "row",
          }}
        >
          <Typography
            variant={matches ? "subtitle2" : "subtitle1"}
            sx={{
              display: "flex",
              flexDirection: "row",
              width: matches ? "100%" : "50%",
              margin: "20px 0",
            }}
          >
            <Box sx={{ width: "160px" }}>
              營業時間<br></br>
              Operation hours
            </Box>
            <Box>
              {previewOperationTimeEN}
              <br />
              {previewOperationTimeTC}
            </Box>
          </Typography>
        </Box>
        <Divider sx={{ borderColor: "rgba(0, 0, 0, 0.6)" }} />

        <Typography
          variant="subtitle2"
          sx={{ color: "rgba(0, 0, 0, 0.6)", marginTop: "20px" }}
        >
          No changes can be made after the submission. <br />
          申請一經提交，將不能再作更改。
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
        <LoadingButton
          variant="outlined"
          sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
          onClick={back}
        >
          Go Back
          <br />
          上一步
        </LoadingButton>
        <LoadingButton
          variant="outlined"
          sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
          loading={isLoading}
          onClick={() => handleSubmitForm()}
        >
          Submit
          <br />
          確認提交
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default ConfirmPage;
